import { create } from 'zustand'
import { Me } from '../service/user'

// 사용자 정보 관련 전역 상태 관리

interface UserStore {
  userInfo: Me | null
  isLoading: boolean
  refetch: (() => void) | null
  set: (payload: Partial<UserStore>) => void
  setLoading: (loading: boolean) => void
  setRefetch: (refetch: () => void) => void
  setUserInfo: (userInfo: Me | null) => void
  destroy: () => void
}

const useUserStore = create<UserStore>((set) => ({
  userInfo: null,
  isLoading: true,
  refetch: null,
  set: (payload) => set((state) => ({ ...state, ...payload })),
  setLoading: (loading) => set({ isLoading: loading }),
  setRefetch: (refetch) => set({ refetch }),
  setUserInfo: (userInfo) => set({ userInfo }),
  destroy: () => set({ userInfo: null, isLoading: true, refetch: null }),
}))

export default useUserStore
